// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--DeSA1","text":"_4f720283bf--text--Az9sJ","desktop":"_4f720283bf--desktop--Yg90O","mobile":"_4f720283bf--mobile--rQfs4"};